import React, { Component, createRef } from "react";
import { Link } from "react-router-dom";
import "./stylesheets/servicereport.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  deleteGeneratedJob,
  deletePickJob,
  documentsUpload,
  generatePickListJob,
  getBackSiteid,
  getDocumentSelectId,
  getServiceGeneratedJobs,
  getServiceInvoicedJobs,
  getServicePickJobs,
  getServicePickJobsData,
  getServicePickSignedJobs,
  getServiceReport,
  getServiceSignedJobs,
  getServicegeneratedJobsData,
  getUploadDetails,
  saveGeneratedJob,
  savePickJobs,
  savePickListJob,
  saveSignedJob,
  signedGeneratedJob,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from "react-bootstrap-table-next";
import Moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-datepicker";
import { IoIosInformationCircle } from "react-icons/io";
import { IoCalendarNumberOutline } from "react-icons/io5";
import { FiChevronsRight } from "react-icons/fi";
import {
  FaPlusCircle,
  FaMinusCircle,
  FaArrowAltCircleRight,
  FaCalendar,
  FaDownload,
  FaQuestion,
} from "react-icons/fa";
import {
  Button,
  Dropdown,
  Offcanvas,
  FloatingLabel,
  Form,
  Table,
  Modal,
} from "react-bootstrap";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import overlayFactory from "react-bootstrap-table2-overlay";
import Select from "react-select";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { MdOutlinePreview } from "react-icons/md";

export default class ServiceReport extends Component {
  constructor(props) {
    super(props);
    this.bootstrapTableRef = createRef(); // Create a ref for Bootstrap Table

    const dateRange = [null, null];
    // const [startDate, endDate] = dateRange;

    this.state = {
      showData: false,
      scroll: false,
      startDate: null,
      calendarOpen: false,
      customerNameFilter: null,
      srIdFilter: null,
      jobFilter: null,
      endDate: null,
      backdrop: false,
      placement: "end",
      lodingImagData: false,
      showTooltip: false,
      showTooltipBox: false,
      dateRange: dateRange,
      srdetails: [],
      srSaveDate: "",
      srInvoicedDate: "",
      srSignedDate: "",
      documentArr: [],
      invoiceData: [],
      SRData: [],
      generatedSrData: "",
      AllowedFileExtensions: "",
      SRDataInvoice: [],
      selectedRows: [],
      customerJobData: "",
      showModal: false,
      ImageType: "",
      AllowedFileExtensions: "",
      MaxAllowedSize: "",
      imageId: "",
      Comment: "",
      invoicedNumber: "",
      imageData: "",
      expanded: [0, 1],
      image: require("../../../assets/images/blank-photo-image.png"),
      currnetmonthdata: new Date(),
      customer: "Equipment",
      listStatus: [
        { key: "0", value: "Jobs" },
        { key: "10", value: "Pick List" },
        { key: "20", value: "Generated" },
        { key: "30", value: "Signed" },
        { key: "40", value: "Invoiced" },
      ],
      statusId: "0",
      selectedStatus: "Jobs",
      siteId: 0,
      selectedSite: "Site Id",
      editBtn: "",
      customerId: "",
      listSiteId: "",
      branchId: "",
      Permission: "",
      submitbtn: false,
      pickbtnEnabled: false,
      loading: false,
      showbtn: false,
      loadingData: "No data found",
    };
    this.wrapperRef = React.createRef();
    this.toggleCalendar = this.toggleCalendar.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleDataRemoveDetails = this.handleDataRemoveDetails.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseEnterFetch = this.handleMouseEnterFetch.bind(this);
    this.handleMouseLeaveFetch = this.handleMouseLeaveFetch.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    var ApplicationTenantID = readDataSelected.ApplicationTenantID;
    var editBtn = false;
    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);
    const filteredData = permissionsreadData.filter((obj) => {
      return (
        obj.PermissionCode === "VALIDATE_JOB" ||
        obj.PermissionCode === "AUTHORIZE_JOB"
      );
    });
    if (filteredData.length > 0) {
      if (filteredData[0].PermissionCode === "VALIDATE_JOB") {
        this.setState({
          Permission: filteredData[0].PermissionCode,
        });
      } else if (filteredData[0].PermissionCode === "AUTHORIZE_JOB") {
        this.setState({
          Permission: filteredData[0].PermissionCode,
        });
      }
    } else {
      this.setState({
        Permission: "",
      });
    }
    var sendDataSite = {
      userid: userId,
      applicationtenantId: ApplicationTenantID,
    };
    const fetchsiteid = async () => {
      const responsesites = await getBackSiteid(sendDataSite);
      const datarespsites = await responsesites;

      var sendDataBgType = {
        selectionType: 10,
      };

      const responseBgType = await getDocumentSelectId(sendDataBgType);
      const datarespBgType = await responseBgType;

      var SrGeneratedTypeIdArr = [];
      for (var i = 0; i < datarespBgType.length; i++) {
        var SrTypeId = {};
        SrTypeId.SelectionID = datarespBgType[i].SelectionID;
        SrTypeId.SelectionValue = datarespBgType[i].SelectionValue;
        SrGeneratedTypeIdArr.push(SrTypeId);
      }

      // var sendData={
      //   selectionType:90,
      //   applicationtenantId:ApplicationTenantID
      // }
      // const responseEquipment = await getBackSelectionType(sendData);
      // const datarespEquipment  = await responseEquipment;

      // var sendDataComponent={
      //   selectionType:100,
      //   applicationtenantId:ApplicationTenantID
      // }
      // const responseComponent = await getBackSelectionType(sendDataComponent);
      // const datarespComponent  = await responseComponent;

      var siteIdArr = [];
      for (var i = 0; i < datarespsites.length; i++) {
        var siteId = {};
        siteId.key = datarespsites[i].SiteID;
        siteId.value = datarespsites[i].SiteName;
        siteId.BranchID = datarespsites[i].BranchID;
        siteIdArr.push(siteId);
      }

      const responseUploadsDetails = await getUploadDetails();
      const datarespUploadsDetails = await responseUploadsDetails;
      var FileType = responseUploadsDetails;

      // var equipmentIdArr = [];
      // for (var i = 0; i < datarespEquipment.length; i++) {
      //   var equipmentId={};
      //   equipmentId.key = datarespEquipment[i].SelectionID;
      //   equipmentId.value = datarespEquipment[i].SelectionValue;
      //   equipmentIdArr.push(equipmentId);
      // }

      // var componentIdArr = [];
      // for (var i = 0; i < datarespComponent.length; i++) {
      //   var componentId={};
      //   componentId.key = datarespComponent[i].SelectionID;
      //   componentId.value = datarespComponent[i].SelectionValue;
      //   componentIdArr.push(componentId);
      // }

      this.setState({
        listSiteId: siteIdArr,
        selectedSite: siteIdArr[0].value,
        SrGeneratedTypeIdArr: SrGeneratedTypeIdArr,
        branchId: siteIdArr[0].BranchID,
        siteId: siteIdArr[0].key,
        uploadDetailsArr: FileType,
        AllowedFileExtensions: FileType[0].AllowedFileExtensions,
        MaxAllowedSize: FileType[0].MaxAllowedSize + " MB",
        // listEquipmentId:equipmentIdArr,
        // selectedEquipment:equipmentIdArr[0].value,
        // equipmentId:equipmentIdArr[0].key,
        // listComponentId:componentIdArr,
        // selectedComponent:componentIdArr[0].value,
        // componentId:componentIdArr[0].key,
        editBtn: editBtn,
      });
    };
    fetchsiteid();
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.statusId !== this.state.statusId) {
      console.log("StatusId updated:", this.state.statusId);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleOutsideClick(event) {
    // if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
    //   this.setState({
    //     calendarOpen: false,
    //   });
    // }
    console.log("ewjkhekf");
  }

  handleInputFetch = (event) => {
    var AllowanceArr = [];
    var submitbtn = true;
    var loadingData = "No data found";
    const siteId = this.state.siteId;

    this.setState({
      loading: true,
      loadingData: "Loading...",
    });

    if (this.state.selectedStatus === "Jobs") {
      const [startDateRange, endDateRange] = this.state.dateRange;

      var sendData = {
        siteId: siteId,
        startDate: Moment(startDateRange).format("YYYY-MM-DD"),
        endDate: Moment(endDateRange).format("YYYY-MM-DD"),
      };
      const fetchMappingdetails = async () => {
        var MappingArr = [];
        const responseMapping = await getServiceReport(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
          this.setState({
            loading: false,
            loadingData: "No data found",
          });
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          customerId: datarespMapping[0].CustomerID,
          loading: false,
          loadingData: "No data found",
        });
      };
      fetchMappingdetails();
    } else if (this.state.selectedStatus === "Pick List") {
      var sendData = {
        siteId: siteId,
        CustomerID: null,
      };
      const fetchPickJobs = async () => {
        var MappingArr = [];
        const responseMapping = await getServicePickJobs(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
          this.setState({
            loading: false,
          });
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          loading: false,
          loading: false,
          //  loadingData: loadingData,
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    } else if (this.state.selectedStatus === "Signed") {
      var sendData = {
        siteId: siteId,
        CustomerID: null,
      };
      const fetchPickJobs = async () => {
        var MappingArr = [];
        const responseMapping = await getServiceSignedJobs(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
          this.setState({
            loading: false,
          });
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          loading: false,
          loading: false,
          //  loadingData: loadingData,
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    } else if (this.state.selectedStatus === "Invoiced") {
      var sendData = {
        siteId: siteId,
      };
      const fetchPickJobs = async () => {
        var MappingArr = [];
        const responseMapping = await getServiceInvoicedJobs(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping === 200) {
          console.log(datarespMapping);
          this.setState({
            loading: false,
          });
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          loading: false,
          loading: false,
          loadingData: loadingData,
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    } else {
      var sendData = {
        siteId: siteId,
        CustomerID: null,
      };
      const fetchGeneratedJobs = async () => {
        var MappingArr = [];
        const responseMapping = await getServiceGeneratedJobs(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          loading: false,
          loading: false,
          loadingData: loadingData,
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchGeneratedJobs();
    }
  };

  toggleCalendar = () => {
    this.setState((prevState) => ({
      calendarOpen: !prevState.calendarOpen,
    }));
  };

  handleSavePick = () => {
    if (this.state.statusId === "0") {
      const siteId = this.state.siteId;
      const branchId = this.state.branchId;
      const CustomerID = this.state.customerId;

      this.setState({
        loading: true,
      });

      const submitPickList = async () => {
        const accesstokendata = localStorage.getItem("access_token");
        const readData = JSON.parse(accesstokendata);
        const userId = readData.userdata.user_id;
        var ApplicationTenantID = 0;
        const accessselectedtentant = localStorage.getItem("selected_tenant");
        if (
          accessselectedtentant !== "" &&
          accessselectedtentant !== null &&
          accessselectedtentant !== undefined
        ) {
          const readDataSelected = JSON.parse(accessselectedtentant);
          ApplicationTenantID = readDataSelected.ApplicationTenantID;
        }

        const { selectedRows } = this.state;

        const JobSRs = [];
        selectedRows.forEach((row) => {
          JobSRs.push({
            JobSRid: row.JobID,
            JobEndDate: Moment(row.JobEndDateTime).format("YYYY-MM-DD"),

            ActualJobDetails:
              "Date: " +
              Moment(row.JobStartDateTime).format("DD-MMM-YYYY") +
              ", Conv.ref: " +
              row.ConveyorReference +
              ", Work: " +
              row.JobType +
              ", Measures: " +
              row.Measures,
            SRJobDetails: "Note",
            JobType: row.JobType,
            OPFlag: "N",
          });
        });

        var sendData = {
          Siteid: siteId,
          BranchID: branchId,
          ModifiedBy: userId,
          CustomerID: CustomerID,
          ApplicationTenantID: ApplicationTenantID,
          JobSRs: JobSRs,
        };

        const responseMapping = await savePickJobs(sendData);
        const datarespMapping = await responseMapping;

        if (datarespMapping === 200) {
          this.handleInputFetch();
        }

        this.setState({
          srdetails: [],
          show: false,
          loading: false,
          submitbtn: false,
        });
      };

      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          submitPickList();
          this.setState({
            selectedRows: [],
          });
          this.handleInputFetch();
        }
      });
    } else {
      const siteId = this.state.siteId;
      const branchId = this.state.branchId;
      const CustomerID = this.state.customerId;

      const signedPickList = async () => {
        const accesstokendata = localStorage.getItem("access_token");
        const readData = JSON.parse(accesstokendata);
        const userId = readData.userdata.user_id;
        var ApplicationTenantID = 0;
        const accessselectedtentant = localStorage.getItem("selected_tenant");
        if (
          accessselectedtentant !== "" &&
          accessselectedtentant !== null &&
          accessselectedtentant !== undefined
        ) {
          const readDataSelected = JSON.parse(accessselectedtentant);
          ApplicationTenantID = readDataSelected.ApplicationTenantID;
        }

        const { selectedRows } = this.state;

        const srIdsString = selectedRows.map((row) => row.ID).join(",");

        var sendData = {
          sr_ids: srIdsString,
          ModifiedBy: userId,
          ApplicationTenantID: ApplicationTenantID,
        };

        const responseMapping = await getServicePickSignedJobs(sendData);
        const datarespMapping = await responseMapping;

        console.log("datarespMapping", datarespMapping);

        if (datarespMapping.length > 0) {
          this.handleShow("Invoice", datarespMapping);
        }

        // this.setState({
        //   srdetails: [],
        //   show: false,
        //   submitbtn: false,
        // });
      };

      // Swal.fire({
      //   title: "Are you sure?",
      //   icon: "warning",
      //   showCancelButton: true,
      //   allowOutsideClick: false,
      //   cancelButtonColor: "#d33",
      //   confirmButtonText: "Yes",
      //   cancelButtonText: "No",
      //   reverseButtons: true,
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     signedPickList();
      //     this.setState({
      //       selectedRows: [],
      //     });
      //     //  this.handleInputFetch();
      //     this.handleShow("Invoice", datarespMapping);
      //   }
      // });
      signedPickList();
    }
  };

  handleSavePickJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;

    const submitPickList = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      var ApplicationTenantID = 0;
      const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
        const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

      const JobSRs = [];
      this.state.SRData.forEach((row) => {
        JobSRs.push({
          JobSRid: row.JobID,
          JobEndDate: "2000-03-04",
          ActualJobDetails: row.ActualJobDetails,
          SRJobDetails: row.SRJobDetails,
          JobType: row.JobType,
          OPFlag: row.deleted ? "D" : "E",
        });
      });

      var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        SrDate: Moment(this.state.srSaveDate).format("YYYY-MM-DD"),
        PICKID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        JobSRs: JobSRs,
      };

      const responseMapping = await savePickListJob(sendData);
      const datarespMapping = await responseMapping;

      console.log(datarespMapping);

      if (datarespMapping === 200) {
        console.log("dattatata");
        this.setState({
          srSaveDate: "",
        });
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitPickList();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

  handleSaveGenerateJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;

    const submitGenerateList = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      var ApplicationTenantID = 0;
      const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
        const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

      var documentArr = this.state.documentArr;
      console.log("documentArr", documentArr);

      var AllDocuments = [];

      if (documentArr.length > 0) {
        console.log("documentArr", documentArr);
        for (let index = 0; index < documentArr.length; index++) {
          const element = {};
          if (documentArr[index].DocumentID) {
            // If it's already uploaded, use the existing data
            element.SelectionID = documentArr[index].SelectionID;
            element.DocumentID = documentArr[index].DocumentID;
            element.FileName = documentArr[index].FileName;
            element.Description = documentArr[index].Description;
            element.UploadedBy = userId;
            element.SRDocumentID = documentArr[index].SRDocumentID;
            element.IsActive = true;
            AllDocuments.push(element);
          } else if (documentArr[index].ImageType === 1) {
            // If it's a new document, upload it
            var uploadedDocument = {
              document: documentArr[index].imageData,
              selection_type: documentArr[index].selectionType,
            };

            console.log("uploadedDocument", uploadedDocument);
            var resp = await documentsUpload(uploadedDocument);
            if (!resp) {
              this.setState({
                lodingImagData: false,
              });
            }
            var documentData = resp.document_id;
            var documentIdDate = documentData;
            element.SelectionID = documentArr[index].SelectionID;
            element.DocumentID = documentIdDate;
            element.FileName = documentArr[index].FileName;
            element.Description = documentArr[index].Description;
            element.UploadedBy = userId;
            element.SRDocumentID = documentArr[index].SRDocumentID;
            element.IsActive = true;
            AllDocuments.push(element);
          }
        }
      }

      console.log("AllDocuments", AllDocuments);

      const JobSRs = [];
      this.state.SRData.forEach((row) => {
        JobSRs.push({
          JobEndDate: "2000-03-04",
          JobSRid: row.JobID,
          ActualJobDetails: row.ActualJobDetails,
          SRJobDetails: row.SRJobDetails,
          OPFlag: row.deleted ? "D" : "E",
        });
      });

      // const SRSaveDocuments = [];
      // this.state.documentArr.forEach((row) => {
      //   SRSaveDocuments.push({
      //     SRDocumentID: row.SRDocumentID,
      //     SelectionID: row.SelectionID,
      //     DocumentID: row.SRJobDetails,
      //     UploadedBy: row.deleted ? "D" : "E",
      //     FileName: row.JobID,
      //     IsActive: row.ActualJobDetails,
      //     Description: row.Description,
      //   });
      // });

      var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        SrSignedDt: Moment(this.state.srSaveDate).format("YYYY-MM-DD"),
        SRID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        SRSaveDocuments: AllDocuments,
        JobSRs: JobSRs,
      };

      const responseMapping = await saveGeneratedJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.setState({
          srSaveDate: "",
          lodingImagData: false,
        });
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
        lodingImagData: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitGenerateList();
        this.setState({
          selectedRows: [],

          lodingImagData: true,
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

  handleSignedGenerateJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;

    const submitGenerateList = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      var ApplicationTenantID = 0;
      const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
        const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

      var documentArr = this.state.documentArr;

      var AllDocuments = [];

      if (documentArr.length > 0) {
        console.log("documentArr", documentArr);
        for (let index = 0; index < documentArr.length; index++) {
          const element = {};
          if (documentArr[index].ImageType === 1) {
            var uploadedDocument = {
              document: documentArr[index].imageData,
              selection_type: documentArr[index].selectionType,
            };

            // console.log("uploadedDocument", uploadedDocument);
            var resp = await documentsUpload(uploadedDocument);
            if (!resp) {
              this.setState({
                lodingImagData: false,
              });
            }
            var documentData = resp.document_id;
            var documentIdDate = documentData;
            element.SelectionID = documentArr[index].SelectionID;
            element.DocumentID = documentIdDate;
            element.FileName = documentArr[index].FileName;
            element.Description = documentArr[index].Description;
            element.UploadedBy = userId;
            element.SRDocumentID = documentArr[index].SRDocumentID;
            element.IsActive = true;
            AllDocuments.push(element);
          }
        }
      }

      const JobSRs = [];
      this.state.SRData.forEach((row) => {
        JobSRs.push({
          JobSRid: row.JobID,
          JobEndDate: "2000-03-04",
          ActualJobDetails: row.ActualJobDetails,
          SRJobDetails: row.SRJobDetails,
          OPFlag: row.deleted ? "D" : "E",
        });
      });

      // const SRSaveDocuments = [];
      // this.state.documentArr.forEach((row) => {
      //   SRSaveDocuments.push({
      //     SRDocumentID: row.SRDocumentID,
      //     SelectionID: row.SelectionID,
      //     DocumentID: row.SRJobDetails,
      //     UploadedBy: row.deleted ? "D" : "E",
      //     FileName: row.JobID,
      //     IsActive: row.ActualJobDetails,
      //     Description: row.Description,
      //   });
      // });

      var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        SrSignedDt: Moment(this.state.srSaveDate).format("YYYY-MM-DD"),
        SRID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        SRSaveDocuments: AllDocuments,
        JobSRs: JobSRs,
      };

      const responseMapping = await signedGeneratedJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
        this.setState({
          lodingImagData: false,
        });
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitGenerateList();
        this.setState({
          selectedRows: [],
          lodingImagData: true,
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

  handleSaveSignedJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;

    const submitSignedJob = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      var ApplicationTenantID = 0;
      const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
        const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

      var documentArr = this.state.documentArr;

      // var AllDocuments = [];

      // if (documentArr.length > 0) {
      //   console.log("documentArr", documentArr);
      //   for (let index = 0; index < documentArr.length; index++) {
      //     const element = {};
      //     if (documentArr[index].ImageType === 1) {
      //       var uploadedDocument = {
      //         document: documentArr[index].imageData,
      //         selection_type: documentArr[index].selectionType,
      //       };

      //       console.log("uploadedDocument", uploadedDocument);
      //       var resp = await documentsUpload(uploadedDocument);
      //       if (!resp) {
      //         this.setState({
      //           lodingImagData: false,
      //         });
      //       }
      //       var documentData = resp.document_id;
      //       var documentIdDate = documentData;
      //       element.SelectionID = documentArr[index].SelectionID;
      //       element.DocumentID = documentIdDate;
      //       element.FileName = documentArr[index].FileName;
      //       element.Description = documentArr[index].Description;
      //       element.UploadedBy = userId;
      //       element.SRDocumentID = documentArr[index].SRDocumentID;
      //       element.IsActive = true;
      //       AllDocuments.push(element);
      //     }
      //   }
      // }

      const JobSRs = [];
      this.state.invoiceData.forEach((row) => {
        JobSRs.push({
          JobSRid: row.SRID,
          JobEndDate: "2000-03-04",
          ActualJobDetails: "data",
          JobType: "data",
          SRJobDetails: "data",
          OPFlag: "E",
        });
      });

      // const SRSaveDocuments = [];
      // this.state.documentArr.forEach((row) => {
      //   SRSaveDocuments.push({
      //     SRDocumentID: row.SRDocumentID,
      //     SelectionID: row.SelectionID,
      //     DocumentID: row.SRJobDetails,
      //     UploadedBy: row.deleted ? "D" : "E",
      //     FileName: row.JobID,
      //     IsActive: row.ActualJobDetails,
      //     Description: row.Description,
      //   });
      // });

      var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        InvoiceDate: Moment(this.state.srInvoicedDate).format("YYYY-MM-DD"),
        InvoiceNum: this.state.invoicedNumber,
        // SRID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        // SRSaveDocuments: AllDocuments,
        JobSRs: JobSRs,
      };

      const responseMapping = await saveSignedJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitSignedJob();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

  handleDeletePickJob = (data) => {
    const deletePickList = async () => {
      var sendData = {
        pick_list_id: data.ID,
      };

      const responseMapping = await deletePickJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deletePickList();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
      }
    });
  };

  handleDeleteGeneratedJob = (data) => {
    const deletePickList = async () => {
      var sendData = {
        sr_id: data.ID,
      };

      const responseMapping = await deleteGeneratedJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deletePickList();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
      }
    });
  };

  handleGeneratePickJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;

    const submitPickList = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      var ApplicationTenantID = 0;
      const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
        const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

      const JobSRs = [];
      this.state.SRData.forEach((row) => {
        JobSRs.push({
          JobSRid: row.JobID,
          JobEndDate: "2000-03-04",
          ActualJobDetails: row.ActualJobDetails,
          SRJobDetails: row.SRJobDetails,
          JobType: row.JobType,
          OPFlag: row.deleted ? "D" : "E",
        });
      });

      var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        CustomerID: this.state.customerJobData.CustomerId,
        SrDate: Moment(this.state.srSaveDate).format("YYYY-MM-DD"),
        PICKID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        JobSRs: JobSRs,
      };

      const responseMapping = await generatePickListJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitPickList();
        this.handleSavePickJob();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

  handleInputChange = (event) => {
    console.log(event);
    const [startDate, endDate] = event;
    const bothSelected = startDate && endDate;
    this.setState({
      dateRange: event,
      calendarOpen: !bothSelected,
      srdetails: [],
      show: false,
      submitbtn: false,
    });
  };

  handleSrSaveDateChange = (event) => {
    this.setState({
      srSaveDate: event,
    });
  };

  handleSrSaveInvoiceDateChange = (event) => {
    this.setState({
      srInvoicedDate: event,
    });
  };

  copyActualJobDetails = (index) => {
    const { SRData } = this.state;
    const updatedSRData = [...SRData];
    const actualJobDetails = updatedSRData[index]?.ActualJobDetails;

    // Update the SR Job Details with the Actual Job Details
    updatedSRData[index].SRJobDetails = actualJobDetails;

    // Update the state with the modified SRData
    this.setState({ SRData: updatedSRData });
  };

  handleInputSRDetailChange(index, value) {
    const updatedSRData = [...this.state.SRData];
    updatedSRData[index].SRJobDetails = value;
    this.setState({ SRData: updatedSRData });
  }

  handleDropdownSite = (key, event) => {
    // console.log(event.target.innerHTML);
    this.setState({
      selectedSite: event.target.innerHTML,
      siteId: key,
      srdetails: [],
      loadingData: "No data found",
      submitbtn: false,
      selectedRows: [],
      showData: false,
    });
  };

  handleDropdown = (key, event) => {
    this.setState({
      selectedStatus: event.target.innerHTML,
      statusId: key,
      dateRange: [null, null],
      loadingData: "No data found",
      srSaveDate: "",
      srdetails: [],
      SRData: [],
      selectedRows: [],
      show: false,
      showData: false,
      submitbtn: false,
    });

    this.handleClearFilter();
  };

  handleClearFilter = () => {
    const { customerNameFilter, srIdFilter, jobFilter } = this.state;
    if (customerNameFilter) customerNameFilter("");
    if (srIdFilter) srIdFilter("");
    if (jobFilter) jobFilter("");
  };

  handleDataAddDetails = (event) => {
    event.preventDefault();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    var newelement = {
      Job: [],
      Work: "Pulley Lagging",
      Measurements:
        "Length (mm): 22, Width (mm): 56, Thickness (mm): 67, Face Length (mm): 76, Dia (mm): 20",
      Dept: "MECHANICAL",
      ConvRef: "5",
      Date: "30-Oct-2023 09:00 AM-30-Oct-2023 12:45 PM - 225 Min",
      WorkOther: "Pulley Lagging",
      MeasurementsOther:
        "Length (mm): 22, Width (mm): 56, Thickness (mm): 67, Face Length (mm): 76, Dia (mm): 20",
      DeptOther: "MECHANICAL",
      ConvRefOther: "5",
      DateOther: "30-Oct-2023 09:00 AM-30-Oct-2023 12:45 PM - 225 Min",
    };
    this.setState((prevState) => ({
      SRData: [...prevState.SRData, newelement],
    }));
  };

  handleDataRemoveDetails(index) {
    // Update the state to mark the row as deleted
    const updatedSRData = [...this.state.SRData];
    updatedSRData[index].deleted = true;
    this.setState({ SRData: updatedSRData });
  }

  handleDataAddDetailsInvoice = (event) => {
    event.preventDefault();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    var newelement = {
      Job: [],
      Work: 0,
    };
    this.setState((prevState) => ({
      SRDataInvoice: [...prevState.SRDataInvoice, newelement],
    }));
  };

  handleDataRemoveDetailsInvoice = (event) => {
    this.setState({
      SRDataInvoice: this.state.Job.filter(function (SRDataInvoice, i) {
        // if(i === event && JobMaterialsEngg.KnownLanguageID !== 0){
        //   deleteknownlanguagedata(LanguagesData.KnownLanguageID);
        // }
        return i !== event;
      }),
    });
  };

  areAllDeleted() {
    return this.state.SRData.every((item) => item.deleted);
  }

  handleDataChangeCheckList = (i) => (event) => {
    this.setState((state, props) => {
      var name = event.target.name;
      state.SRData[i][name] = event.target.value;
      return {
        SRData: state.SRData,
      };
    });
  };

  handleClose = (event) => {
    this.setState({
      showData: false,
      documentArrData: [],
      documentArr: [],
      SRData: [],

      srInvoicedDate: "",
      invoicedNumber: "",
    });
  };

  handleCloseModal = (selected) => {
    this.setState({
      showModal: false,
      ImageType: "",
      image: require("../../../assets/images/blank-photo-image.png"),
      // AllowedFileExtensions: "",
      // MaxAllowedSize: "",
      Comment: "",
      imageId: "",
      imageData: "",
    });
  };

  handleShowModal = (selected) => {
    this.setState({
      showModal: true,
    });
  };

  handleCloseModalBig = (selected) => {
    this.setState({
      showModalBig: false,
      Comment: " ",
    });
  };

  handleShowModalBig = async (selected, DocumentID) => {
    var ApplicationTenantID = 0;
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    if (
      accessselectedtentant !== "" &&
      accessselectedtentant !== null &&
      accessselectedtentant !== undefined
    ) {
      const readDataSelected = JSON.parse(accessselectedtentant);
      ApplicationTenantID = readDataSelected.ApplicationTenantID;
    }
    var urlObject = selected;
    const token = JSON.parse(localStorage.getItem("auth"));
    if (DocumentID !== "" && DocumentID !== null && DocumentID !== undefined) {
      var url =
        process.env.REACT_APP_API_URL +
        "/documents/" +
        DocumentID +
        "/?application_tenant_id=" +
        ApplicationTenantID;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const blob = await res.blob();
      urlObject = URL.createObjectURL(blob);
    }

    this.setState({
      showModalBig: true,
      // viewFile:selected,
      viewFile: urlObject,
    });
  };

  handleDataRemoveImage = (event) => {
    var msg = "Are you sure you want to delete?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          documentArr: this.state.documentArr.filter(function (
            documentArrData,
            i
          ) {
            // if(i === event && documentArrData.DocumentID !== 0){
            //   deleteImage(documentArrData);
            // }
            return i !== event;
          }),
        });
      }
    });
  };

  handleChangeImageDataOther = (event) => {
    console.log(event.target.value);
    console.log(event.target);
    const MySwal = withReactContent(Swal);
    var checkImageData = event.target.files[0];
    var uploadDetailsArr = this.state.uploadDetailsArr;
    console.log("uploadDetailsArr", uploadDetailsArr);
    // const filteredData = uploadDetailsArr.filter((obj) => {
    //   return obj.SelectionType === parseInt(event.target.value);
    // });

    if (
      event.target.files[0] !== "" &&
      event.target.files[0] !== null &&
      event.target.files[0] !== undefined
    ) {
      if (uploadDetailsArr.length >= 0) {
        console.log("uploadDetailsArr", uploadDetailsArr);
        var fileName = event.target.files[0].name;
        var patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
        var fileExtension = fileName.match(patternFileExtension);
        const MIN_FILE_SIZE = uploadDetailsArr[0].MaxAllowedSize * 1024;
        const fileSizeKiloBytes = checkImageData.size / 1024;
        const uploadedFileType = checkImageData.type;
        const fileType = uploadDetailsArr[0].AllowedFileExtensions;
        const fileTypeArray = fileType.split(",");
        const filteredFileType = fileTypeArray.find(
          (element) =>
            element === fileExtension[0] ||
            element.toUpperCase() === fileExtension[0]
        );
        if (
          filteredFileType !== undefined &&
          filteredFileType !== null &&
          filteredFileType !== ""
        ) {
          if (fileSizeKiloBytes < MIN_FILE_SIZE) {
            this.setState({
              imageId: checkImageData.name,
              typeImage: fileExtension[1],
              imageData: checkImageData,
              image: URL.createObjectURL(event.target.files[0]),
            });
          } else {
            var msg =
              "Maximum file size allowed " +
              uploadDetailsArr[0].MaxAllowedSize +
              "MB";
            MySwal.fire(msg);
          }
        } else {
          var msg = "File type not allowed";
          MySwal.fire(msg);
        }
      } else {
        var msg = "Please select file type first";
        MySwal.fire(msg);
      }
    }
  };

  copyAllTasks = () => {
    const { srSaveDate, SRData } = this.state;

    console.log("SRData before copying tasks:", SRData);
    console.log("Selected date:", srSaveDate);

    if (!Array.isArray(SRData)) {
      console.error("SRData is not an array:", SRData);
      return;
    }

    try {
      this.setState(
        (prevState) => {
          const updatedSRData = prevState.SRData.map((row, index) => {
            if (!row.hasOwnProperty("ActualJobDetails")) {
              console.error(
                `Row at index ${index} is missing 'ActualJobDetails' property:`,
                row
              );
              throw new Error(
                `Row at index ${index} is missing 'ActualJobDetails' property`
              );
            }
            return {
              ...row,
              SRJobDetails: row.ActualJobDetails,
            };
          });
          return { SRData: updatedSRData };
        },
        () => {
          console.log("Copy all tasks executed successfully.");
          console.log("SRData after copying tasks:", this.state.SRData);
        }
      );
    } catch (error) {
      console.error("An error occurred while copying all tasks:", error);
      alert("An error occurred. Please try again.");
    }
  };

  handleChangeImage = (event) => {
    event.preventDefault();
    const MySwal = withReactContent(Swal);
    var checkImageData = this.state.imageData;
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.display_name;
    var uploadDetailsArr = this.state.uploadDetailsArr;
    const filteredData = uploadDetailsArr.filter((obj) => {
      return obj.SelectionType === 10;
    });
    var SrGeneratedTypeIdArr = this.state.SrGeneratedTypeIdArr;
    console.log("SrGeneratedTypeIdArr", SrGeneratedTypeIdArr);
    // const filteredDataMain = selectionImage.filter((obj) => {
    //   return obj.SelectionType === parseInt(this.state.ImageType);
    // });
    if (
      checkImageData !== "" &&
      checkImageData !== null &&
      checkImageData !== undefined
    ) {
      if (filteredData.length > 0) {
        var fileName = checkImageData.name;
        var patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
        var fileExtension = fileName.match(patternFileExtension);
        const MIN_FILE_SIZE = filteredData[0].MaxAllowedSize * 1024;
        const fileSizeKiloBytes = checkImageData.size / 1024;
        const uploadedFileType = checkImageData.type;
        const fileType = filteredData[0].AllowedFileExtensions;
        const fileTypeArray = fileType.split(",");
        const filteredFileType = fileTypeArray.find(
          (element) =>
            element === fileExtension[0] ||
            element.toUpperCase() === fileExtension[0]
        );
        if (
          filteredFileType !== undefined &&
          filteredFileType !== null &&
          filteredFileType !== ""
        ) {
          if (fileSizeKiloBytes < MIN_FILE_SIZE) {
            this.setState({
              lodingImagData: true,
            });
            var uploadedOn = Moment(new Date()).format("DD-MMM-YYYY HH:mm");
            var userData = this.state.documentArr;
            var element = {};
            element.SelectionID = SrGeneratedTypeIdArr[0].SelectionID;
            element.selectionType = 10;
            element.FileName = this.state.imageId;
            element.imageUrl = this.state.image;
            element.imageData = this.state.imageData;
            element.Description = this.state.Comment;
            element.SRDocumentID = 0;
            element.UploadedOn = uploadedOn;
            element.DocumentID = 0;
            element.ImageType = 1;
            element.SelectionValue = SrGeneratedTypeIdArr[0].SelectionValue;
            element.DeleteFlag = true;
            element.UploadedBy = userId;
            userData.push(element);
            this.setState(
              {
                documentArr: userData,
              },
              () => {
                this.setState({
                  imageId: "",
                  imageData: "",
                  ImageType: "",
                  image: require("../../../assets/images/blank-photo-image.png"),
                  showModal: false,
                  lodingImagData: false,
                  Comment: "",
                });
              }
            );
          } else {
            var msg =
              "Maximum file size allowed " +
              filteredData[0].MaxAllowedSize +
              "MB";
            MySwal.fire(msg);
          }
        } else {
          var msg = "File type not allowed";
          MySwal.fire(msg);
        }
      } else {
        var msg = "Please select file type first";
        MySwal.fire(msg);
      }
    } else {
      var msg = "Please select file";
      MySwal.fire(msg);
    }
  };

  handleMouseEnter() {
    this.setState({ showTooltip: true });
  }

  handleMouseLeave() {
    this.setState({ showTooltip: false });
  }

  handleMouseEnterFetch() {
    this.setState({ showTooltipBox: true });
  }

  handleMouseLeaveFetch() {
    this.setState({ showTooltipBox: false });
  }

  navigateToServiceReportPreview = (id) => {
    // Set the ID in localStorage
    localStorage.setItem("service_report_id", "Generated");
  };

  navigateToServiceReportPreviewSigned = (id) => {
    localStorage.setItem("service_report_id", "Signed");
  };

  navigateToServiceReportPreviewPickList = (id) => {
    localStorage.setItem("service_report_id", "PickList");
  };

  navigateToServiceReportPreviewInvoice = (id) => {
    localStorage.setItem("service_report_id", "Invoice");
  };

  handleDataRemoveImage = (event) => {
    var msg = "Are you sure you want to delete?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          documentArr: this.state.documentArr.filter(function (
            documentArrData,
            i
          ) {
            if (i === event && documentArrData.DocumentID !== 0) {
              // deleteImage(documentArrData);
            }
            return i !== event;
          }),
        });
      }
    });
  };

  getInitialBid = (oldValue, newValue, row, column) => {
    var indexData = row.index;
    var valueData = 0;
    //   for (let index = 1; index < 32; index++) {
    //     var indexvaldata = "D"+index;
    //     if(row[indexvaldata] !== '' && row[indexvaldata] !== undefined){
    //       valueData += parseFloat(row[indexvaldata]);
    //     }
    //   }
    //   this.setState((state, props) => {
    //     state.allowancedetails[indexData].Total = valueData;
    //     return {
    //       allowancedetails: state.allowancedetails,
    //     }
    //   }, () => {
    //     const collection = document.getElementsByClassName("demo-row-odd"+row.TechnicianID+"");
    //     collection[0].style.color = "red";
    //     const collectiondata = document.getElementsByClassName("demo-row-odd-data"+row.TechnicianID+"");
    //     collectiondata[0].style.color = "red";
    // });

    // return this.state.data.find(r => r.rank === row.rank).initialBid;
  };

  handleShow = (event, data) => {
    if (event === "New") {
      this.setState({
        customerJobData: data,
      });
      var sendData = {
        pick_id: data.ID,
      };
      const fetchPickJobs = async () => {
        const responseMapping = await getServicePickJobsData(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
        } else {
          // loadingData = "No data found";
        }
        this.setState({
          SRData: datarespMapping,
          srSaveDate: datarespMapping[0]?.SRDate
            ? Moment(datarespMapping[0]?.SRDate).toDate()
            : "",
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    } else if (event === "Invoice") {
      this.setState({
        invoiceData: data,
      });
    } else {
      this.setState({
        customerJobData: data,
      });
      var sendData = {
        sr_id: data.ID,
      };
      const fetchPickJobs = async () => {
        const responseMapping = await getServicegeneratedJobsData(sendData);

        this.setState({
          generatedSrData: responseMapping,
          documentArr: responseMapping?.SRDocuments,
          srSaveDate: responseMapping?.SRSignedDate
            ? Moment(responseMapping?.SRSignedDate).toDate()
            : "",
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    }
    this.setState({ showData: true, selectedBtn: event, customer: event });
  };

  handleDataChangeOther = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleDataChangeComment = (event) => {
    const inputValue = event.target.value;
    if (inputValue.length <= 250) {
      this.setState({ Comment: inputValue });
    }
  };

  render() {
    // let customerNameFilter = null;
    // let srIdFilter = null;
    // let jobFilter = null;

    const SRData = this.state.SRData;

    const SRDataInvoice = this.state.SRDataInvoice;
    const addUserLogo = require("../../../assets/images/add_user.png");
    const terminationLogo = require("../../../assets/images/termination.png");
    const loadingImg = require("../../../assets/images/Hourglass.gif");
    var listSiteId = this.state.listSiteId;
    var listStatus = this.state.listStatus;
    var documentArr = this.state.documentArr;

    console.log("selectedRows", this.state.selectedRows);

    // var customerFilter;

    var columns = [];
    if (this.state.statusId === "20") {
      columns = [
        {
          dataField: "ID",
          text: "SR #",
          classes: "cursorPoint id-width",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ srIdFilter: filter });
            },
          }),
          sort: true,
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow("Upload Signed SR", row);
            },
          },
        },
        {
          dataField: "CustomerName",
          text: "Customer",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow("Upload Signed SR", row);
            },
          },
          classes: "cursorPoint customerName-Width",
          // filter: textFilter({ className: "filter_class" }),
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
          sort: true,
        },
        {
          dataField: "JobSRTypeIds",
          classes: "cursorPoint",
          text: "Jobs",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow("Upload Signed SR", row);
            },
          },
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
          sort: true,
        },
        {
          dataField: "SRDate",
          classes: "cursorPoint srDate-Width",
          text: "SR Date",
          // filter: textFilter({ className: "filter_class" }),
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow("Upload Signed SR", row);
            },
          },
          sort: true,
          formatter: (cellContent, row) => {
            return Moment(row.SRDate).format("DD-MMM-YYYY");
          },
        },
        {
          dataField: "Action",
          text: "Action",
          classes: "actionbtncustm",
          isDummyField: true,
          editable: false,
          formatter: (cellContent, row) => {
            return (
              <span>
                <span className="saveBtnUs">
                  {/* <img src={terminationLogo}
                             alt="logo" className="logo-user" title='Generate SR' onClick={() => {this.handleShow('New')}}/> */}
                  <Link
                    target="_blank"
                    to={`/service-report-preview/${row.ID}`}
                    onClick={() => this.navigateToServiceReportPreview(row.ID)}
                    className="linkPage"
                  >
                    <MdOutlinePreview size={20} title="Preview" />{" "}
                  </Link>
                </span>
                {/* {this.state.Permission === "VALIDATE_JOB" ? (
                  <span
                    className="saveBtnUsMi cursorPoint marginLeft"
                    onClick={() => this.handleDeleteGeneratedJob(row)}
                    // disabled={item?.deleted}
                  >
                    <FaMinusCircle className="btnClassMinus" title="Delete" />
                  </span>
                ) : (
                  ""
                )} */}
                <span
                  className="saveBtnUsMi cursorPoint marginLeft"
                  onClick={() => this.handleDeleteGeneratedJob(row)}
                  // disabled={item?.deleted}
                >
                  <FaMinusCircle className="btnClassMinus" title="Delete" />
                </span>
              </span>
            );
          },
        },
      ];
    } else if (this.state.statusId === "30") {
      columns = [
        {
          dataField: "ID",
          text: "SR #",
          // filter: textFilter({ className: "filter_class" }),
          classes: "cursorPoint id-width",
          sort: true,
          // events: {
          //   onClick: (e, column, columnIndex, row, rowIndex) => {
          //     this.handleShow("Invoice", row);
          //   },
          // },
        },
        {
          dataField: "CustomerName",
          text: "Customer",
          classes: "cursorPoint customerName-Width",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
          sort: true,
        },
        {
          dataField: "JobSRTypeIds",
          text: "Jobs",
          classes: "cursorPoint",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
          sort: true,
        },
        {
          dataField: "SRDate",
          text: "SR Date",
          classes: "cursorPoint srDate-Width",
          formatter: (cellContent, row) => {
            return Moment(row.SRDate).format("DD-MMM-YYYY");
          },
        },
        {
          dataField: "Action",
          text: "Action",
          classes: "actionbtncustm",
          isDummyField: true,
          editable: false,
          formatter: (cellContent, row) => {
            return (
              <span>
                <span className="saveBtnUs">
                  {/* <img src={terminationLogo}
                             alt="logo" className="logo-user" title='Generate SR' onClick={() => {this.handleShow('New')}}/> */}
                  <Link
                    target="_blank"
                    to={`/service-report-preview/${row.ID}`}
                    onClick={() =>
                      this.navigateToServiceReportPreviewSigned(row.ID)
                    }
                    className="linkPage"
                  >
                    <MdOutlinePreview size={20} title="Preview" />{" "}
                  </Link>
                </span>
                {/* <span
                  className="saveBtnUsMi cursorPoint marginLeft"
                  onClick={() => this.handleDeleteGeneratedJob(row)}
                  // disabled={item?.deleted}
                >
                  <FaMinusCircle className="btnClassMinus" />
                </span> */}
              </span>
            );
          },
        },
      ];
    } else if (this.state.statusId === "40") {
      columns = [
        {
          dataField: "InvoiceID",
          text: "Invoice #",
          // filter: textFilter({ className: "filter_class" }),
          classes: "cursorPoint id-width",
          // sort: true,
          // events: {
          //   onClick: (e, column, columnIndex, row, rowIndex) => {
          //     this.handleShow("Invoice", row);
          //   },
          // },
        },
        {
          dataField: "CustomerName",
          text: "Customer",
          classes: "cursorPoint customerName-Width",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
          sort: true,
        },
        {
          dataField: "JobSRIds",
          text: "SRs",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
          sort: true,
          // formatter: (cellContent, row) => {
          //   return (
          //     <Link
          //       target="_blank"
          //       to="/service-report-preview"
          //       className="linkPage"
          //     >
          //       {cellContent}
          //     </Link>
          //   );
          // },
        },
        {
          dataField: "DocDate",
          text: "Invoice Date",
          classes: "cursorPoint srDate-Width",
          formatter: (cellContent, row) => {
            return Moment(row.DocDate).format("DD-MMM-YYYY");
          },
        },
        {
          dataField: "Action",
          text: "Action",
          classes: "actionbtncustm",
          isDummyField: true,
          editable: false,
          formatter: (cellContent, row) => {
            return (
              <span>
                <span className="saveBtnUs">
                  {/* <img src={terminationLogo}
                             alt="logo" className="logo-user" title='Generate SR' onClick={() => {this.handleShow('New')}}/> */}
                  <Link
                    target="_blank"
                    to={`/service-report-preview/${row.ID}`}
                    onClick={() =>
                      this.navigateToServiceReportPreviewInvoice(row.ID)
                    }
                    className="linkPage"
                  >
                    <MdOutlinePreview size={20} title="Preview" />{" "}
                  </Link>
                </span>
              </span>
            );
          },
        },
      ];
    } else if (this.state.statusId === "0") {
      columns = [
        {
          dataField: "JobID",
          text: "Job#",
          formatter: (cellContent, row) => {
            let className = "linkPage";
            let statusText = cellContent;

            if (row.JobStatus === "Validated") {
              className += " orangeText"; // Define a class for orange color
              statusText = "Validated";
            } else if (row.JobStatus === "HOApproved") {
              className += " greenText"; // Define a class for orange color
              statusText = "HOApproved";
            }

            return (
              <span className="linkPage">
                {cellContent}{" "}
                <IoIosInformationCircle
                  className={className}
                  size={15}
                  title={statusText}
                />{" "}
              </span>
            );
          },
          classes: (cell, row, rowIndex, colIndex) => {
            var currnetMonthData = this.state.currnetmonthdata;
            var currnetMonth = "";
            if (currnetMonthData === "") {
              currnetMonth = new Date();
            } else {
              currnetMonth = currnetMonthData;
            }
            var StatusValue = ["60", "80"];
            var dateVali = false;
            var selectedMonthData = Moment(currnetMonth).format("MM");
            var currentMonthData = Moment(new Date()).format("MM");
            var checkDate =
              Moment(currentMonthData).isBefore(selectedMonthData);
            dateVali = checkDate;

            if (this.state.Permission === "VALIDATE_JOB") {
              if (this.state.statusId === "10") {
                return "cursor jobidtd";
              }
            } else if (this.state.Permission === "AUTHORIZE_JOB") {
              if (
                this.state.statusId === "60" ||
                this.state.statusId === "80"
              ) {
                if (
                  this.state.submitbtn === true &&
                  StatusValue.some(
                    (element) => element === this.state.statusId
                  ) === true
                ) {
                  return "cursor jobidtd";
                } else {
                  return "jobidtd";
                }
              }
            } else {
              return "jobidtd";
            }
          },
          sort: true,
          headerClasses: "jobidtd",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ srIdFilter: filter });
            },
          }),
        },
        {
          dataField: "CustomerName",
          text: "Customer",
          sort: true,
          headerClasses: "customertd",
          classes: "customertd",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
        },
        {
          dataField: "JobType",
          text: "Work",
          sort: true,
          headerClasses: "jobtypetd",
          classes: "jobtypetd",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
        },
        {
          dataField: "TechNames",
          text: "Technicians",
          headerClasses: "technametd",
          classes: "technametd",
        },
        {
          dataField: "Remarks",
          text: "Remarks",
          headerClasses: "remarktd",
          classes: "remarktd",
        },
        {
          dataField: "Measures",
          text: "Measurements",
          headerClasses: "measurestd",
          classes: "measurestd",
        },
        // {
        //   dataField: "Materials",
        //   text: "Materials",
        //   headerClasses: "materialstd",
        //   classes: "materialstd",
        // },
        {
          dataField: "Department",
          text: "Dept",
          sort: true,
          headerClasses: "departmenttd",
          classes: "departmenttd",
          filter: textFilter({ className: "filter_class" }),
        },
        {
          dataField: "ConveyorReference",
          text: "Conv Ref",
          sort: true,
          headerClasses: "conveyorreferencetd",
          classes: "conveyorreferencetd",
          filter: textFilter({ className: "filter_class" }),
        },
        {
          dataField: "JobDates",
          text: "Date & Time",
          headerClasses: "jobdatetd",
          classes: "jobdatetd",
        },
        {
          dataField: "NumberOfCasuals",
          headerClasses: "numberofcasualtd",
          text: "Casuals",
          classes: "numberofcasualtd",
        },
      ];
    } else {
      columns = [
        {
          dataField: "ID",
          text: "Pick #",
          classes: "cursorPoint pickListWidth",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ srIdFilter: filter });
            },
          }),
          sort: true,
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow("New", row);
            },
          },
        },
        {
          dataField: "CustomerName",
          text: "Customer",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow("New", row);
            },
          },
          sort: true,
          classes: "cursorPoint pickListNameWidth",
        },
        {
          dataField: "JobSRTypeIds",
          text: "Jobs",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
          sort: true,
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow("New", row);
            },
          },
          classes: "cursorPoint",
          formatter: (cellContent, row) => {
            return <span className="linkPage">{cellContent}</span>;
          },
        },
        {
          dataField: "Action",
          text: "Action",
          classes: "actionbtncustm",
          isDummyField: true,
          editable: false,
          formatter: (cellContent, row) => {
            return (
              <span>
                <span className="saveBtnUs">
                  {/* <img src={terminationLogo}
                             alt="logo" className="logo-user" title='Generate SR' onClick={() => {this.handleShow('New')}}/> */}
                  <Link
                    target="_blank"
                    to={`/service-report-preview/${row.ID}`}
                    onClick={() =>
                      this.navigateToServiceReportPreviewPickList(row.ID)
                    }
                    className="linkPage"
                  >
                    <MdOutlinePreview size={20} title="Preview" />{" "}
                  </Link>
                </span>
                {/* {this.state.Permission === "VALIDATE_JOB" ? (
                  <span
                    className="saveBtnUsMi cursorPoint marginLeft"
                    onClick={() => this.handleDeletePickJob(row)}
                    // disabled={item?.deleted}
                  >
                    <FaMinusCircle className="btnClassMinus" title="Delete" />
                  </span>
                ) : (
                  ""
                )} */}
                <span
                  className="saveBtnUsMi cursorPoint marginLeft"
                  onClick={() => this.handleDeletePickJob(row)}
                  // disabled={item?.deleted}
                >
                  <FaMinusCircle className="btnClassMinus" title="Delete" />
                </span>
              </span>
            );
          },
        },
      ];
    }

    const StartDateCustomInput = React.forwardRef(({ value, onClick }, ref) => (
      <button className="start-custom-input" onClick={onClick} ref={ref}>
        {value ? Moment(value).format("DD-MMM-YYYY") : "Start Date"}
      </button>
    ));

    const EndDateCustomInput = React.forwardRef(({ value, onClick }, ref) => (
      <button className="start-custom-input" onClick={onClick} ref={ref}>
        {value ? Moment(value).format("DD-MMM-YYYY") : "End Date"}
      </button>
    ));

    const columnsOther = [
      {
        dataField: "Job",
        text: "Job #",
        editable: false,
      },
      {
        dataField: "Customer",
        text: "Customer",
        editable: false,
      },
      {
        dataField: "Work",
        text: "Work",
        editable: false,
      },
      {
        dataField: "Measurements",
        text: "Measurements",
        editable: false,
      },
      {
        dataField: "JobDate",
        text: "Job Date",
        editable: false,
      },
      {
        dataField: "Work",
        text: "Work",
        editCellClasses: "editing-name",
      },
      {
        dataField: "Measurements",
        text: "Measurements",
        editCellClasses: "editing-name",
      },
      {
        dataField: "JobDate",
        text: "Job Date",
        editCellClasses: "editing-name",
      },
    ];
    var servicereportData = this.state.srdetails;
    // var productsOther = this.state.srdetails;

    // var productsOther = [
    //   {
    //     Jobs: 4,
    //     Customer: "L&T",
    //     Work: "Work",
    //     Measurements: 25,
    //     JobDate: "28-Oct-2023",
    //   },
    // ];

    var expandRow = {};

    // if (this.state.statusId !== "0") {
    //   expandRow = {
    //     className: "expanding-foo",
    //     showExpandColumn: true,
    //     expandByColumnOnly: true,
    //     renderer: (row) => (
    //       <div className="table-container-user">
    //         <BootstrapTable
    //           classes="tabledata-user"
    //           keyField="JobID"
    //           id="tabledata"
    //           data={productsOther}
    //           columns={columnsOther}
    //           loading={this.state.loading}
    //           cellEdit={cellEditFactory({
    //             mode: "click",
    //             blurToSave: true,
    //             afterSaveCell: (oldValue, newValue, row, column) => {
    //               this.getInitialBid(oldValue, newValue, row, column);
    //             },
    //           })}
    //           noDataIndication={this.state.loadingData}
    //         />
    //       </div>
    //     ),

    //     nonExpandable: this.state.expanded,
    //     // expandByColumnOnly: true,
    //     onExpand: this.handleOnExpand,
    //   };
    // }

    // const selectRow = {
    //   mode: "checkbox",
    //   clickToSelect: true,
    //   selected: this.state.selectedRows.map((row) => row.ID || row.JobID),
    //   className: "checkbox-column",
    //   // hideSelectColumn: true, // Hide the checkbox column
    //   // hideSelectAll: true,

    //   onSelect: (row, isSelect, rowIndex, e) => {
    //     let updatedSelectedRows;
    //     if (isSelect) {
    //       // console.log("selecttttt");
    //       // If row is selected, add it to the selectedRows array
    //       updatedSelectedRows = [...this.state.selectedRows, row];
    //     } else {
    //       // console.log("Notttt selecttttt");
    //       // If row is unselected, remove it from selectedRows array
    //       updatedSelectedRows = this.state.selectedRows.filter(
    //         (selectedRow) => selectedRow !== row
    //       );
    //     }
    //     this.setState({
    //       selectedRows: updatedSelectedRows,
    //     });

    //     // Check if there are different CustomerNames in selectedRows array
    //     const customerNames = updatedSelectedRows.map(
    //       (row) => row.CustomerName
    //     );
    //     if (new Set(customerNames).size > 1) {
    //       // If there are different customer names
    //       this.setState({
    //         pickbtnEnabled: false,
    //       });
    //     } else {
    //       this.setState({
    //         pickbtnEnabled: true,
    //       });
    //     }
    //   },
    //   hideSelectColumn:
    //     this.state.statusId === "0" || this.state.statusId === "30"
    //       ? false
    //       : true,
    // };

    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
      selected: this.state.selectedRows.map((row) => row.ID || row.JobID),
      className: "checkbox-column",
      hideSelectAll: false, // Show the "Select All" checkbox

      // Individual row selection
      onSelect: (row, isSelect, rowIndex, e) => {
        let updatedSelectedRows;
        if (isSelect) {
          // If row is selected, add it to the selectedRows array
          updatedSelectedRows = [...this.state.selectedRows, row];
        } else {
          // If row is unselected, remove it from selectedRows array
          {
            this.state.statusId === "30"
              ? (updatedSelectedRows = this.state.selectedRows.filter(
                  (selectedRow) =>
                    selectedRow.ID !== row.ID && selectedRow.ID !== row.ID
                ))
              : (updatedSelectedRows = this.state.selectedRows.filter(
                  (selectedRow) =>
                    selectedRow.JobID !== row.JobID &&
                    selectedRow.JobID !== row.JobID
                ));
          }
        }
        this.setState({
          selectedRows: updatedSelectedRows,
        });

        // Check if there are different CustomerNames in selectedRows array
        const customerNames = updatedSelectedRows.map(
          (row) => row.CustomerName
        );
        if (new Set(customerNames).size > 1) {
          // If there are different customer names
          this.setState({
            pickbtnEnabled: false,
          });
        } else {
          this.setState({
            pickbtnEnabled: true,
          });
        }
      },

      // "Select All" functionality
      onSelectAll: (isSelect, rows, e) => {
        let updatedSelectedRows;
        if (isSelect) {
          // If "Select All" is clicked, add all rows to selectedRows array
          updatedSelectedRows = [...this.state.selectedRows, ...rows];
        } else {
          // If "Deselect All" is clicked, remove all rows from selectedRows array
          updatedSelectedRows = [];
        }
        this.setState({
          selectedRows: updatedSelectedRows,
        });

        // Check if there are different CustomerNames in selectedRows array
        const customerNames = updatedSelectedRows.map(
          (row) => row.CustomerName
        );
        if (new Set(customerNames).size > 1) {
          this.setState({
            pickbtnEnabled: false,
          });
        } else {
          this.setState({
            pickbtnEnabled: true,
          });
        }
      },

      hideSelectColumn:
        this.state.statusId === "0" || this.state.statusId === "30"
          ? false
          : true,
    };

    const pickbtnEnabled =
      this.state.selectedRows.length > 0 && this.state.pickbtnEnabled;

    const [startDateRange, endDateRange] = this.state.dateRange;

    console.log(startDateRange, endDateRange);

    const hasEmptySRDetail = SRData.some(
      (item) => !item.deleted && item.SRJobDetails === ""
    );

    const fetchbtnEnabled = startDateRange && endDateRange;
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-user">
            <div className="filterbtnsite">
              <Dropdown onSelect={this.handleDropdownSite}>
                <Dropdown.Toggle
                  variant="warning"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedSite}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listSiteId !== ""
                    ? listSiteId.map((item, indexdata) => {
                        return (
                          <Dropdown.Item
                            className="font_size"
                            key={indexdata}
                            eventKey={item.key}
                          >
                            {item.value}
                          </Dropdown.Item>
                        );
                      })
                    : ""}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div
              className={
                this.state.statusId === "0" || this.state.statusId === "30"
                  ? "filterbtndrop"
                  : "filterbtn"
              }
            >
              <Dropdown onSelect={this.handleDropdown}>
                <Dropdown.Toggle
                  variant="info"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedStatus}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listStatus.map((item, index) => {
                    return (
                      <Dropdown.Item
                        className="font_size"
                        key={index}
                        eventKey={item.key}
                      >
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {this.state.statusId === "0" ? (
              <div
                ref={this.wrapperRef}
                className="filterbtndate dateRangePicker"
              >
                <button
                  className="btn dateRange-btn"
                  onClick={this.toggleCalendar}
                >
                  <IoCalendarNumberOutline
                    size={30}
                    className="calendar-icon"
                  />
                </button>
                <DatePicker
                  // selected={this.state.startDateRangeData}
                  onChange={(update) => {
                    this.handleInputChange(update);
                  }}
                  startDate={startDateRange}
                  endDate={endDateRange}
                  open={this.state.calendarOpen}
                  dateFormat="dd-MMM-yyyy"
                  placeholderText="Select Period"
                  className="form-control fontSize daterange"
                  // isClearable={true}
                  selectsRange={true}
                  minDate={new Date(2024, 2, 1)}
                  maxDate={new Date()}
                  // readOnly={true}
                />
                <div className="showDateRange">
                  {startDateRange
                    ? Moment(startDateRange).format("DD-MMM-YYYY")
                    : ""}
                  {endDateRange
                    ? " - " + Moment(endDateRange).format("DD-MMM-YYYY")
                    : ""}
                </div>

                {/* <DatePicker
                  selected={this.state.startDate}
                  placeholderText="Select Period"
                  className="form-control fontSize daterange"
                  onChange={(date) => this.setState({ startDate: date })}
                  customInput={<StartDateCustomInput />}
                />{" "}
                -{" "}
                <DatePicker
                  selected={this.state.endDate}
                  placeholderText="Select Period"
                  className="form-control fontSize daterange"
                  onChange={(date) => this.setState({ endDate: date })}
                  customInput={<EndDateCustomInput />}
                /> */}
              </div>
            ) : (
              ""
            )}
            <div className="filterbtn">
              <Button
                variant="primary"
                className={`font_size ${
                  this.state.statusId === "0" && !endDateRange
                    ? "disabledBtn"
                    : ""
                }`}
                disabled={this.state.statusId === "0" && !endDateRange}
                onClick={this.handleInputFetch}
              >
                Fetch
              </Button>
              {this.state.statusId === "0" && (
                <span className="pickbtn-note">
                  <IoIosInformationCircle
                    size={20}
                    onMouseEnter={this.handleMouseEnterFetch}
                    onMouseLeave={this.handleMouseLeaveFetch}
                  />
                </span>
              )}
              {this.state.showTooltipBox && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    width: "150px",
                    // left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    zIndex: 9999,
                  }}
                >
                  Select Period and Click on the fetch button.
                </div>
              )}
            </div>
          </div>
          <div className="submiteditbtnsr" style={{ position: "relative" }}>
            {this.state.statusId === "30" || this.state.statusId === "0" ? (
              // this.state.Permission === "VALIDATE_JOB" ? (
              <>
                <Button
                  variant="warning"
                  className={`font_size ${pickbtnEnabled ? "" : "disabledBtn"}`}
                  onClick={this.handleSavePick}
                  disabled={!pickbtnEnabled}
                >
                  Pick
                </Button>
                <span className="pickbtn-note">
                  <IoIosInformationCircle
                    size={20}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                  />
                </span>
                {this.state.showTooltip && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      // left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "rgba(0, 0, 0, 0.8)",
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      zIndex: 9999,
                    }}
                  >
                    The Pick button is disabled until a job is selected (or) if
                    multiple customers jobs are selected.
                  </div>
                )}
              </>
            ) : (
              // ) : (
              //   <span className="submiteditbtnsrOther"></span>
              // )
              <span className="submiteditbtnsrOther"></span>
            )}
            {/* <img src={addUserLogo}
                             alt="logo" className="logo-add-user" title='Generate SR'  onClick={() => {this.handleShow('New')}}/> */}
          </div>
        </div>
        <div className="table-container-user">
          <BootstrapTable
            ref={this.bootstrapTableRef} // Assign the ref to your Bootstrap Table
            classes={
              this.state.statusId === "0" || this.state.statusId === "30"
                ? "tabledata-user-other"
                : "tabledata-user-data"
            }
            keyField={`${this.state.statusId === "30" ? "ID" : "JobID"}`}
            id="tabledata"
            data={servicereportData}
            columns={columns}
            expandRow={expandRow}
            selectRow={selectRow}
            filter={filterFactory({ className: "custom_filter_class" })}
            loading={this.state.loading}
            noDataIndication={this.state.loadingData}
          />
        </div>
        <Offcanvas
          className={
            this.state.selectedBtn === "Invoice"
              ? "useroff-in"
              : "useroff-other"
          }
          show={this.state.showData}
          scroll={this.state.scroll}
          name={this.state.name}
          backdrop={this.state.backdrop}
          placement={this.state.placement}
          onHide={this.handleClose}
        >
          <Offcanvas.Header className="popup_header" closeButton>
            <Offcanvas.Title className="header_title">
              {this.state.selectedBtn === "New" ? (
                <span className="title_contant">
                  Pick List No: {this.state.customerJobData.ID} -{" "}
                  {this.state.customerJobData.CustomerName}
                </span>
              ) : this.state.selectedBtn === "Invoice" ? (
                <span className="title_contant">
                  {/* {this.state.invoiceData[0].CustomerID} -{" "} */}
                  {this.state.invoiceData[0].CustomerName}
                </span>
              ) : (
                <span className="title_contant">
                  SR No/Date : {this.state.customerJobData.ID} /{" "}
                  {Moment(this.state.customerJobData.SRDate).format(
                    "DD-MMM-YYYY"
                  )}{" "}
                  - {this.state.customerJobData.CustomerName}
                </span>
              )}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container">
              <div className="rowUser justify-content-center">
                <div className="col-md-12">
                  {this.state.selectedBtn === "New" ? (
                    <form
                      className="pr-5 mb-5 formUser"
                      method="POST"
                      onSubmit={this.handleAddCustomer}
                    >
                      <div className="rowUserpickList">
                        <div className="col-md-3 form-group input-user dateCol">
                          <label className="fontSize labelWidth">
                            SR Date* :{"  "}
                          </label>
                          <DatePicker
                            selected={this.state.srSaveDate}
                            onChange={(date) => {
                              this.handleSrSaveDateChange(date);
                            }}
                            dateFormat="dd-MMM-yyyy"
                            // minDate={this.state.startDate}
                            //  disabled={this.state.Permission !== "VALIDATE_JOB"}
                            maxDate={this.state.lasttdate}
                            minDate={
                              new Date(
                                Math.max.apply(
                                  null,
                                  SRData.map(
                                    (data) => new Date(data?.JobEndDate)
                                  )
                                )
                              )
                            }
                            required
                            placeholderText="  Select Date"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="rowUser">
                        <div className=" form-group " style={{ width: "100%" }}>
                          <Table bordered responsive className="tableAdd">
                            <thead className="padding-table-header">
                              {/* <th>Sr #<span className="required"> *</span></th> */}
                              <th
                                className=" alginCenter col-md-1 colorHeader"
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  padding: "3px",
                                }}
                              >
                                Job #<span className="required">*</span>
                              </th>
                              <th
                                className="alginCenter col-md-5 colorHeader"
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  position: "relative",
                                }}
                              >
                                <span> Actual Job Details </span>

                                <span
                                  className="copy-all-button ml-2"
                                  onClick={() => this.copyAllTasks()}
                                >
                                  <FiChevronsRight
                                    size={25}
                                    title="Copy All"
                                    color="green"
                                  />
                                </span>
                              </th>
                              <th
                                className="alginCenter col-md-5 colorHeader"
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                SR Job Details
                              </th>

                              <th
                                className="alginCenter col-md-1 colorHeader"
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Action
                              </th>
                            </thead>
                            <tbody>
                              {SRData.map((item, indexle) => {
                                return (
                                  <tr
                                    className={`${
                                      item?.deleted ? "rowDisabled" : ""
                                    } `}
                                    key={indexle}
                                  >
                                    <td className="tableFontSize alginCenter">
                                      {item?.JobID}
                                    </td>
                                    <td
                                      className="tableFontSize alginCenter flexBox relative"
                                      style={{ padding: "16px" }}
                                    >
                                      <span
                                        className={` ${
                                          item?.SRJobDetails === ""
                                            ? "pr-2"
                                            : ""
                                        }`}
                                      >
                                        {" "}
                                        {item?.ActualJobDetails}{" "}
                                      </span>
                                      {item?.SRJobDetails === "" ? (
                                        <span
                                          className="copy-icon ml-2"
                                          onClick={() =>
                                            this.copyActualJobDetails(indexle)
                                          }
                                        >
                                          <FiChevronsRight
                                            size={25}
                                            title="Copy"
                                            color="green"
                                          />
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </td>

                                    <td className="tableFontSize alginCenter">
                                      <textarea
                                        type="text"
                                        scroll={false}
                                        className="form-control noBorder srJobDetailWidth"
                                        required={true}
                                        // disabled={
                                        //   this.state.Permission !==
                                        //   "VALIDATE_JOB"
                                        // }
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          minHeight: "65px",
                                          resize: "none",
                                        }}
                                        value={item?.SRJobDetails || ""} // Set initial value
                                        onChange={(e) =>
                                          this.handleInputSRDetailChange(
                                            indexle,
                                            e.target.value
                                          )
                                        } // Handle change event
                                        name="Work"
                                        placeholder="Enter Job detail"
                                      />
                                    </td>

                                    <td className="alginCenter">
                                      <span
                                        className="saveBtnUsMi cursorPoint"
                                        onClick={() =>
                                          this.handleDataRemoveDetails(indexle)
                                        }
                                        disabled={item?.deleted}
                                      >
                                        <FaMinusCircle
                                          title="Delete"
                                          className="btnClassMinus"
                                        />
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="edit_input submitbtn mt-3">
                        <button
                          type="button"
                          onClick={this.handleSavePickJob}
                          disabled={
                            !this.state.srSaveDate || this.areAllDeleted()
                            // || this.state.Permission !== "VALIDATE_JOB"
                          }
                          className={`btnval btn btn-success font_size ${
                            this.state.srSaveDate || this.areAllDeleted()
                            // || this.state.Permission !== "VALIDATE_JOB"
                            //   ? ""
                            //   : "disabledBtn"
                          }`}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          onClick={this.handleGeneratePickJob}
                          disabled={
                            !this.state.srSaveDate ||
                            hasEmptySRDetail ||
                            this.areAllDeleted()
                            // || this.state.Permission !== "VALIDATE_JOB"
                          }
                          className={`btnvalSr btn btn-primary font_size ${
                            this.state.srSaveDate && !hasEmptySRDetail
                            // || this.state.Permission !== "VALIDATE_JOB"
                            //   ? ""
                            //   : "disabledBtn"
                          }`}
                        >
                          Generate SR
                        </button>
                        <button
                          type="button"
                          onClick={this.handleClose}
                          className="btnval btn btn-warning font_size"
                        >
                          Discard
                        </button>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}
                  {this.state.selectedBtn === "Upload Signed SR" ? (
                    <form
                      className="pr-5 mb-5 formUser"
                      method="POST"
                      onSubmit={this.handleAddCustomer}
                    >
                      <div className="rowUserpickList">
                        <div className="col-md-3 form-group input-user dateCol">
                          <label className="fontSize srlabelWidth">
                            Signed Date* :{" "}
                          </label>
                          <DatePicker
                            selected={this.state.srSaveDate}
                            onChange={(date) => {
                              this.handleSrSaveDateChange(date);
                            }}
                            dateFormat="dd-MMM-yyyy"
                            // minDate={this.state.startDate}
                            maxDate={this.state.lasttdate}
                            // disabled={this.state.Permission !== "VALIDATE_JOB"}
                            minDate={
                              new Date(this.state.generatedSrData.SRDate)
                            }
                            required
                            placeholderText="  Select Date"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="rowUser mt-3 ">
                        <div className="col-md-12 form-group input-user">
                          <Table bordered responsive className="tableAdd">
                            <thead>
                              {/* <th>Sr #<span className="required"> *</span></th> */}
                              <th className=" alginCenter colorHeader">
                                Job #<span className="required">*</span>
                              </th>
                              <th className="alginCenter colorHeader">
                                Actual Job Details
                              </th>
                              <th className="alginCenter colorHeader">
                                SR Job Details
                              </th>

                              {/* <th className="alginCenter colorHeader">
                                Action
                              </th> */}
                            </thead>
                            <tbody>
                              {this.state.generatedSrData?.SRJobsDetail?.map(
                                (item, indexle) => {
                                  return (
                                    <tr
                                      className={`${
                                        item?.deleted ? "rowDisabled" : ""
                                      } `}
                                      key={indexle}
                                    >
                                      <td className="tableFontSize alginCenter">
                                        {item?.JobID}
                                      </td>
                                      <td className="tableFontSize alginCenter">
                                        {item?.ActualJobDetails}
                                      </td>

                                      <td className="tableFontSize alginCenter">
                                        {item?.SRJobDetails}
                                      </td>

                                      {/* <td className="alginCenter">
                                      <span
                                        className="saveBtnUsMi cursorPoint"
                                        onClick={() =>
                                          this.handleDataRemoveDetails(indexle)
                                        }
                                        disabled={item?.deleted}
                                      >
                                        <FaMinusCircle className="btnClassMinus" />
                                      </span>
                                    </td> */}
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="row mt-3 ">
                        <span className="DottedClass"></span>
                        <div className="col-md-12 form-group input-user">
                          <Table bordered responsive>
                            <thead>
                              <th className="alginCenter colorHeader">
                                Document Name
                              </th>
                              <th className="alginCenter colorHeader">
                                Description
                              </th>
                              <th className="alginCenter colorHeader">
                                Uploaded By/On
                              </th>
                              <th className="alginCenter colorHeader taskWithPlus">
                                <span
                                  className="saveBtnUsPl cursorPoint"
                                  disabled={
                                    this.state.Permission !== "VALIDATE_JOB"
                                  }
                                  // onClick={
                                  //   this.state.Permission === "VALIDATE_JOB"
                                  //     ? () => {
                                  //         this.handleShowModal();
                                  //       }
                                  //     : null
                                  // }
                                  onClick={() => this.handleShowModal()}
                                >
                                  <FaPlusCircle title="Add" />
                                </span>
                              </th>
                              <th className="alginCenter"></th>
                            </thead>
                            <tbody>
                              {documentArr.length > 0 ? (
                                documentArr.map((item, indexdata) => {
                                  return (
                                    <tr key={indexdata}>
                                      <td className="alginCenter">
                                        {item.FileName}
                                      </td>
                                      <td className="alginCenter wrapDescription">
                                        {item.Description}
                                      </td>
                                      <td className="alginCenter">
                                        {item.UploadedBy +
                                          " / " +
                                          Moment(item.UploadedOn).format(
                                            "DD-MMM-YYYY"
                                          )}
                                      </td>

                                      <td className="alginCenter taskWithPlus">
                                        <span
                                          className="saveBtnUsMi cursorPoint"
                                          // onClick={
                                          //   this.state.Permission ===
                                          //   "VALIDATE_JOB"
                                          //     ? () =>
                                          //         this.handleDataRemoveImage(
                                          //           indexdata
                                          //         )
                                          //     : null
                                          // }

                                          onClick={() =>
                                            this.handleDataRemoveImage(
                                              indexdata
                                            )
                                          }
                                        >
                                          <FaMinusCircle title="Delete" />
                                        </span>
                                      </td>

                                      {/* <td className="alginCenter cursorPoint">
                                        <FaDownload
                                          onClick={() =>
                                            this.handleImageDownload(
                                              item.FileName,
                                              item.DocumentID
                                            )
                                          }
                                        />
                                      </td> */}
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td className="alginCenter" colSpan={5}>
                                    No Document Uploaded yet!
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="edit_input submitbtn mt-3">
                        <button
                          type="button"
                          onClick={this.handleSaveGenerateJob}
                          disabled={
                            !this.state.srSaveDate || documentArr.length <= 0
                            // || this.state.Permission !== "VALIDATE_JOB"
                          }
                          className={`btnval btn btn-success font_size ${
                            this.state.srSaveDate && documentArr.length > 0
                            // || this.state.Permission !== "VALIDATE_JOB"
                            //   ? ""
                            //   : "disabledBtn"
                          }`}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          onClick={this.handleSignedGenerateJob}
                          disabled={
                            !this.state.srSaveDate || documentArr.length <= 0
                            // || this.state.Permission !== "VALIDATE_JOB"
                          }
                          className={`btnvalSr btn btn-primary font_size ${
                            this.state.srSaveDate && documentArr.length > 0
                            //  || this.state.Permission !== "VALIDATE_JOB"
                            //   ? ""
                            //   : "disabledBtn"
                          }`}
                        >
                          Signed SR
                        </button>
                        <button
                          type="button"
                          onClick={this.handleClose}
                          className="btnval btn btn-warning font_size"
                        >
                          Discard
                        </button>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}
                  {this.state.selectedBtn === "Invoice" ? (
                    <form
                      className="pr-5 mb-5 formUser"
                      method="POST"
                      onSubmit={this.handleAddCustomer}
                    >
                      <div className="rowUser rowUserData">
                        <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            className="lableWidth"
                            label="Invoice #"
                          >
                            <Form.Control
                              className="edit_job_edit form__field"
                              type="text"
                              required={true}
                              name="invoicedNumber"
                              onChange={this.handleDataChangeOther}
                              value={this.state.invoicedNumber}
                              placeholder="Description"
                            />
                          </FloatingLabel>
                        </div>
                        <div className="col-md-6 form-group input-user">
                          <label className="fontSize">Invoice Date *</label>
                          <DatePicker
                            selected={this.state.srInvoicedDate}
                            onChange={(date) => {
                              this.handleSrSaveInvoiceDateChange(date);
                            }}
                            dateFormat="dd-MMM-yyyy"
                            minDate={
                              new Date(
                                Math.max.apply(
                                  null,
                                  this.state.invoiceData.map(
                                    (data) => new Date(data?.SRDate)
                                  )
                                )
                              )
                            }
                            maxDate={this.state.lasttdate}
                            required
                            placeholderText="Date *"
                            className="form-control selectAsealign"
                          />
                        </div>
                      </div>
                      <div className="rowUser">
                        <div className="col-md-12 form-group input-user">
                          <Table bordered responsive className="">
                            <thead>
                              {/* <th>Sr #<span className="required"> *</span></th> */}
                              <th className="taskWith colorHeader alginCenter">
                                SR #<span className="required">*</span>
                              </th>
                              <th className="alginCenter colorHeader">SR Dt</th>
                              {/* <th className="alginCenter taskWithPlus">
                                <span
                                  className="saveBtnUsPl cursorPoint"
                                  onClick={this.handleDataAddDetailsInvoice}
                                >
                                  <FaPlusCircle />
                                </span>
                              </th> */}
                            </thead>
                            <tbody>
                              {this.state.invoiceData.map((item, indexle) => {
                                return (
                                  <tr key={indexle}>
                                    <td className="tableFontSize alginCenter">
                                      {/* <Form.Select
                                        aria-label="Floating label select example"
                                        name="Frequency"
                                        required={true}
                                        onChange={this.handleDataChangeCheckList(
                                          indexle
                                        )}
                                        className="edit_job form__field_select_table table-border"
                                        value={iteamle.Frequency}
                                      >
                                        <option value="">SR</option>
                                        {listFrequencyId !== ''?
                                              listFrequencyId.map((item, indexdata) => {
                                              return (
                                                <option key={indexdata} value={item.key}>
                                                {item.value}</option>
                                                );
                                              })
                                              : ''}
                                      </Form.Select> */}
                                      {item?.SRID}
                                    </td>
                                    <td className="alginCenter">
                                      {Moment(item.SRDate).format(
                                        "DD-MMM-YYYY"
                                      )}
                                    </td>
                                    {/* <td>
                                      <span
                                        className="saveBtnUsMi cursorPoint"
                                        onClick={() =>
                                          this.handleDataRemoveDetailsInvoice(
                                            indexle
                                          )
                                        }
                                      >
                                        <FaMinusCircle className="btnClassMinus" />
                                      </span>
                                    </td> */}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="edit_input submitbtn mt-3">
                        <button
                          type="button"
                          onClick={this.handleSaveSignedJob}
                          disabled={
                            !this.state.srInvoicedDate ||
                            !this.state.invoicedNumber
                          }
                          className={`btnval btn btn-success font_size ${
                            this.state.srInvoicedDate &&
                            this.state.invoicedNumber
                              ? ""
                              : "disabledBtn"
                          }`}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          onClick={this.handleClose}
                          className="btnval btn btn-warning font_size"
                        >
                          Discard
                        </button>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        <Modal
          show={this.state.showModalBig}
          onHide={this.handleCloseModalBig}
          className="backModalBig"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="titleDataOther"
            >
              Uploaded Document
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid">
            <div className="container">
              {/* <TransformWrapper> */}
              {/* <div className="tools">
                    <button onClick={() => zoomIn()}>+</button>
                    <button onClick={() => zoomOut()}>-</button>
                    <button onClick={() => resetTransform()}>x</button>
                  </div> */}
              {/* <TransformComponent contentClass="mainImage"> */}
              {/* <FileViewer
                              fileType={this.state.typeImage}
                              filePath={this.state.viewFile}
                              
                             /> */}
              {/* <DocViewer documents={this.state.viewFile} /> */}
              <iframe
                src={this.state.viewFile}
                className="mainImage"
                width="1040"
                height="500"
              ></iframe>
              {/* </TransformComponent>
                </TransformWrapper> */}
            </div>
          </Modal.Body>
          {/* <Modal.Footer className="footerModel">
                  <p className='contentzoom'>Use the mouse scroll to zoom in and zoom out, and click and drag specific portions of the image,of interest to you.</p>
            </Modal.Footer> */}
        </Modal>
        <Modal
          show={this.state.showModal}
          onHide={this.handleCloseModal}
          dialogClassName="custom-dialog"
          className="backModal"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header className="headerUpload" closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="titleData"
            >
              Upload Document
            </Modal.Title>
          </Modal.Header>
          <form
            className="pr-5 formUser"
            method="POST"
            encType="multipart/form-data"
            onSubmit={this.handleChangeImage}
          >
            <Modal.Body className="show-grid modelImageBox">
              <div className="">
                <div className="rowUser justify-content-center imageUploadClass">
                  <div className="rowImage">
                    <div className="imagecol">
                      {this.state.imageData !== "" &&
                      this.state.imageData !== null &&
                      this.state.imageData !== undefined ? (
                        <p className="fileNameClass">{this.state.imageId}</p>
                      ) : (
                        <div className="profile-pic">
                          <label className="-label" htmlFor="file">
                            <span>&nbsp;</span>
                          </label>
                          <input
                            id="file"
                            type="file"
                            name="fileimage"
                            onChange={this.handleChangeImageDataOther}
                            accept={this.state.AllowedFileExtensions}
                          />
                          <img src={this.state.image} id="output" width="200" />
                        </div>
                      )}
                      <p className="photoClass">
                        Supported file formats :{" "}
                        {this.state.AllowedFileExtensions}
                        <br />
                        Maximum file size : {this.state.MaxAllowedSize}
                      </p>
                      {/* <FloatingLabel
                        controlId="floatingTextarea2"
                        label="Description *"
                      > */}
                      <Form.Control
                        as="textarea"
                        placeholder="Description *"
                        name="Comment"
                        required={true}
                        // style={{ height: '185px' }}
                        onChange={this.handleDataChangeComment}
                        value={this.state.Comment}
                        className="font_size"
                      />
                      {/* </FloatingLabel> */}
                      <p className="photoClass mt-2">
                        <b>
                          Note: The uploaded documents will be saved only on the
                          click of the Save button in the next screen.
                        </b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="footerModel">
              <button className="btn btn-success fontSize">Upload</button>
            </Modal.Footer>
          </form>
        </Modal>
        {this.state.lodingImagData === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }
}
